<template>
  <div>
    <div class="p-4 mb-6" style="border-bottom: 1px solid #cdcdcd; font-size: 16px; font-weight: 500">I. 아래 사항을 직접 기입해 주시기 바랍니다.</div>

    <!-- 기본정보 -->
    <field-select-module class="mb-6" v-model="form.stdInfo" :board="this.board" :is-print="isPrint" :types="['field_name', 'date']" />

    <!-- 증상조사 대상자 정보 -->
    <musculoskeletal-symptoms-survey-table class="mb-6" v-model="form.targetInfo" :is-print="isPrint" :readonly="board.readonly" />

    <!-- 증상조사표표 -->
    <symptom-investigation-table class="mb-6" v-model="form.symptomTable" :is-print="isPrint" :readonly="board.readonly" @result="handleResult"/>

    <!-- 유의사항 -->
    <warning-view
      class="mb-6"
      :list="[
        '부담작업을 수행하는 근로자가 직접 읽어보고 문항을 체크합니다.',
        '증상조사표를 작성할 경우 증상을 과대 또는 과소 평가 해서는 안됩니다.',
        '증상조사 결과는 근골격계질환의 이환을 부정 또는 입증하는 근거나 반증자료로 활용할 수 없습니다.',
      ]"
    />

    <!-- 개선대책-->
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 ">
      <div class="col-span-12 flex items-start">
        <div class="label-text mr-4 mt-2">개선대책</div>
        <span v-if="isPrint" class="print-textarea"> {{form.inputB_1}} </span>
        <ml-textarea v-else class="flex-1 w-full" rows="5" v-model="form.inputB_1" :readonly="board.readonly"/>
      </div>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import MusculoskeletalSymptomsSurveyTable from "@/views/boards/single-page/470/MusculoskeletalSymptomsSurveyTable";
import SymptomInvestigationTable from "@/views/boards/single-page/470/SymptomInvestigationTable";
import WarningView from "@/components/WarningView";

export default {
  components: {
    WarningView,
    SymptomInvestigationTable,
    MusculoskeletalSymptomsSurveyTable,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        targetInfo: {},
        symptomTable: {},
        fileList: [],
        inputB_1: "",

        result: "", // 전체 결과
      },
    };
  },
  methods: {
    handleResult(result) {
      this.form.result = result;
    },
  },
};
</script>

<style scoped lang="scss">
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
  margin-right: 16px;
}
</style>
